import { Facebook, Instagram, Linkedin, Twitter, Youtube, Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const socials = [
  { Icon: Facebook, href: "https://www.facebook.com/mahaview", label: "Facebook" },
  { Icon: Instagram, href: "#", label: "Instagram" },
  { Icon: Linkedin, href: "#", label: "LinkedIn" },
  { Icon: Twitter, href: "#", label: "Twitter" },
  { Icon: Youtube, href: "#", label: "YouTube" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 pt-16 sm:pt-20 md:pt-32 pb-10 px-5 sm:px-6 md:px-10 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-8 md:gap-10 mb-12 md:mb-16">
          <div className="col-span-12 md:col-span-6">
            <a href="#home" data-testid="footer-logo" className="inline-block group">
              <img
                src="https://customer-assets.emergentagent.com/job_digital-presence-hub-12/artifacts/hifm6awv_mahaview-new-tag-logo.png"
                alt="Mahaview Enterprises – Your Growth Partner"
                className="w-40 sm:w-44 md:w-56 h-auto mb-6 group-hover:opacity-90 transition-opacity"
              />
            </a>
            <a href="#contact" data-testid="footer-letstalk" className="block font-display font-semibold tracking-tight leading-none text-4xl sm:text-5xl md:text-6xl text-white hover:text-[#FF5A00] transition-colors">
              Let's talk.
            </a>
            <p className="text-zinc-400 text-sm mt-6 max-w-md">
              Mahaview Enterprises — Mumbai-based digital solutions company helping brands grow
              since 2015.
            </p>
          </div>

          <div className="col-span-12 sm:col-span-6 md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">Company</div>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li><a href="#home" className="hover:text-[#FF5A00] transition-colors">Home</a></li>
              <li><a href="#about" className="hover:text-[#FF5A00] transition-colors">About Us</a></li>
              <li><a href="#services" className="hover:text-[#FF5A00] transition-colors">Services</a></li>
              <li><Link to="/pricing" className="hover:text-[#FF5A00] transition-colors">Pricing</Link></li>
              <li><a href="#process" className="hover:text-[#FF5A00] transition-colors">Process</a></li>
              <li><a href="#contact" className="hover:text-[#FF5A00] transition-colors">Contact</a></li>
            </ul>
          </div>

          <div className="col-span-12 sm:col-span-6 md:col-span-3 min-w-0">
            <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">Reach</div>
            <ul className="space-y-3 text-sm text-zinc-300">
              <li className="flex items-start gap-2 min-w-0">
                <Mail size={14} className="text-[#FF5A00] mt-1 flex-shrink-0" />
                <a href="mailto:mahaview1@gmail.com" className="hover:text-[#FF5A00] transition-colors break-all">mahaview1@gmail.com</a>
              </li>
              <li className="flex items-start gap-2 min-w-0">
                <Phone size={14} className="text-[#FF5A00] mt-1 flex-shrink-0" />
                <a href="tel:+918097208707" className="hover:text-[#FF5A00] transition-colors break-all">+91 80972 08707</a>
              </li>
              <li className="flex items-start gap-2 min-w-0">
                <MapPin size={14} className="text-[#FF5A00] mt-1 flex-shrink-0" />
                <span>Mumbai, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pt-8 border-t border-white/10">
          <div className="flex items-center gap-2 text-sm text-zinc-400">
            <span className="inline-block w-2 h-2 bg-[#FF5A00] flex-shrink-0" />
            <span>© {new Date().getFullYear()} Mahaview Enterprises · All rights reserved.</span>
          </div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-zinc-300">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[#FF5A00] transition-colors">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-[#FF5A00] transition-colors">Terms &amp; Conditions</Link>
          </div>
          <div className="flex items-center gap-3 flex-wrap">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target={s.href.startsWith("http") ? "_blank" : undefined}
                rel={s.href.startsWith("http") ? "noopener noreferrer" : undefined}
                data-testid={`social-${s.label.toLowerCase()}`}
                aria-label={s.label}
                className="w-9 h-9 border border-white/15 hover:border-[#FF5A00] hover:text-[#FF5A00] flex items-center justify-center transition-colors text-zinc-300"
              >
                <s.Icon size={15} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
